export default {"src":"/_next/static/media/mailroom-logo-red.92e396df.svg","height":91,"width":351,"blurWidth":0,"blurHeight":0};